import { render, staticRenderFns } from "./EducationalGroupUpdateWarning.vue?vue&type=template&id=f4250212&"
import script from "./EducationalGroupUpdateWarning.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupUpdateWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports